import styled, { css } from 'styled-components'

import { E_Colors } from '@/helpers/colors'
import { E_CertificateTypes } from '@/enums'

type T_Brand = E_CertificateTypes;

export const SC_Content = styled.div<{ $brand: T_Brand }>`
  font-size: 13px;
  font-weight: 400;
  line-height: 15px;

  & > :first-child { margin-bottom: 12px; }
  & > :last-child { margin-bottom: 24px !important; }

  & p > strong {
    font-weight: 500;
    font-size: 17px;
    line-height: 110%;
  }

  & > :nth-child(n + 2) {
    background-color: ${E_Colors.GrayF2F2F7};
    margin: 0;
    padding: 6px 16px;
  }

  & > :nth-child(2) {
    border-top-left-radius: 24px;
    border-top-right-radius: 24px;
    padding-top: 16px;
  }

  & > :last-child {
    border-bottom-left-radius: 24px;
    border-bottom-right-radius: 24px;
    padding-bottom: 16px;
  }

  & ol {
    list-style: none;
    padding: 0;
    counter-reset: step;
    margin-left: 0;
  }
  & ol > li {
    display: flex;
    gap: 8px;
    margin: 0 0 8px 0;
    counter-increment: step;
    align-items: center;
    font-size: 14px;
    font-weight: 400;
    line-height: 17px;
  }
  & ol > li::before {
    content: counter(step, decimal-leading-zero);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    border-radius: 999px;
    font-weight: 600;
    background: ${E_Colors.White};
    color: ${E_Colors.MainColorAccent};
    flex: none;
    font-size: 14px;
    font-weight: 900;
  }

  & ul { margin-left: 1.25em; padding: 0; list-style: disc; }
  & li { margin: 6px 0; }

  ${({ $brand }) => $brand === E_CertificateTypes.Pyaterochka && css`
    & > :nth-child(n + 2) {
      background: none;
      padding: 0;
      border-radius: 0;
    }

    & p:has(> strong),
    & p:has(> strong) + ol,
    & p:has(> strong) + ol + p:not(:has(> strong)) {
      background-color: ${E_Colors.GrayF2F2F7} !important;
      margin: 0 !important;
      padding: 6px 16px !important;
    }

    & p:has(> strong) {
      border-top-left-radius: 24px !important;
      border-top-right-radius: 24px !important;
      padding-top: 16px !important;
      margin-top: 16px !important;
    }

    & p:has(> strong) + ol + p:not(:has(> strong)) {
      border-bottom-left-radius: 24px !important;
      border-bottom-right-radius: 24px !important;
      padding-bottom: 16px !important;
    }

    & > ol:nth-of-type(2) {
      border-bottom-left-radius: 24px !important;
      border-bottom-right-radius: 24px !important;
      padding-bottom: 16px !important;
    }
  `}
`

export const SC_InstructionHeader = styled.div`
  h2 {
    font-weight: 400;
    font-size: 17px;
    line-height: 14px;
  }

  span {
    font-size: 11px;
    color: rgba(46, 47, 51, 0.44);
    line-height: 13px;
    font-weight: 400;
  }
`
